import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: null,
    snackbar: {
      message: "",
      type: "info",
    },
    orders: null,
    initializing: true,
  },
  getters: {
    getUser: (state) => state.user,
    initializing: (state) => state.initializing,
  },
  mutations: {
    updateUser(state, userObject) {
      state.user = userObject.user;
    },
    clearAuth(state) {
      state.user = null;
    },
    initing(state) {
      state.initializing = false;
    },
    SNACKBAR(state, payload) {
      state.snackbar = payload.payload;
    },
  },
  actions: {
    initing({ commit }) {
      commit("initing");
    },
    updateUser({ commit }, user) {
      commit("updateUser", user);
    },
    clearAuth(context) {
      context.commit("clearAuth");
    },
    updateUserStripeId({ commit }, stripeId) {
      commit("updateUserStripeId", stripeId);
    },
    SNACKBAR({ commit }, payload) {
      commit("SNACKBAR", payload);
    },
  },
  plugins: [createPersistedState()],
});
